var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8 21.6001H4.79998C3.4745 21.6001 2.39999 20.5256 2.39999 19.2001L2.40009 4.80013C2.4001 3.47466 3.47461 2.40015 4.80009 2.40015H15.6004C16.9258 2.40015 18.0004 3.47466 18.0004 4.80015V9.60015M17.4 17.3491V17.286M6.60037 7.20015H13.8004M6.60037 10.8001H13.8004M6.60037 14.4001H10.2004M21.6 17.4001C21.6 17.4001 20.6038 20.3398 17.4 20.2885C14.1961 20.2371 13.2 17.4001 13.2 17.4001C13.2 17.4001 14.1558 14.4091 17.4 14.4091C20.6442 14.4091 21.6 17.4001 21.6 17.4001Z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus);
export default __webpack_public_path__ + "static/media/status.bcf71135c296cf9eb504d0f3d286f40f.svg";
export { ForwardRef as ReactComponent };